import {createSeededRandom} from '@github-ui/use-stable-random'
import {useId, useMemo} from 'react'

import type {CopilotAnimationStateProps} from '../types'
import styles from './Activate.module.css'
import Celebrate from './Celebrate'

export default function CopilotAnimationActivate({scale = 1, state}: CopilotAnimationStateProps) {
  const sparkleId = useId()
  const sparkleStyles = useMemo(() => {
    const rand = createSeededRandom(sparkleId)
    return Array.from({length: 10}).map((_, i) => ({
      animationDelay: `${(rand(i * 3, 10) * 0.01 + 0.2).toFixed(2)}s`,
      animationDuration: `${(0.4 + rand(i * 3 + 1, 20) * 0.01).toFixed(2)}s`,
      transform: `scale(${(rand(i * 3 + 2, 20) * 0.01 + 0.8).toFixed(2)})`,
    }))
  }, [sparkleId])

  return (
    <div className={styles.activate} data-animation-state={state}>
      <div className={styles.copilot}>
        <Celebrate scale={scale} state={state} />
      </div>

      <div className={styles.sparkles}>
        {sparkleStyles.map((sparkle, index) => (
          <div
            className={styles.sparkle}
            // eslint-disable-next-line @eslint-react/no-array-index-key
            key={index}
            style={{animationDelay: sparkle.animationDelay, animationDuration: sparkle.animationDuration}}
          >
            <div
              className={styles.sparkleTrail}
              style={{animationDelay: sparkle.animationDelay, animationDuration: sparkle.animationDuration}}
            />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={16 * scale}
              height={16 * scale}
              viewBox="0 0 16 16"
              style={{animationDelay: sparkle.animationDelay, transform: sparkle.transform}}
              aria-hidden="true"
            >
              <path d="M7.53 1.282a.5.5 0 0 1 .94 0l.478 1.306a7.492 7.492 0 0 0 4.464 4.464l1.305.478a.5.5 0 0 1 0 .94l-1.305.478a7.492 7.492 0 0 0-4.464 4.464l-.478 1.305a.5.5 0 0 1-.94 0l-.478-1.305a7.492 7.492 0 0 0-4.464-4.464L1.282 8.47a.5.5 0 0 1 0-.94l1.306-.478a7.492 7.492 0 0 0 4.464-4.464Z" />
            </svg>
          </div>
        ))}
      </div>
    </div>
  )
}
